import { Icon, IconKebab } from '@flixbus/honeycomb-icons-react';
import { Button, Dropdown, DropdownItem, Text } from '@flixbus/honeycomb-react';

import { MODAL_NAMES } from 'common/activeElements/modals/modalNames';
import { deriveBreakdownSegment } from 'common/BreakdownDetails/deriveBreakdownSegment';
import { useActiveElements } from 'global/ActiveElements/useActiveElements';
import { formatDateDisplay, formatTime } from 'utils/datetime';

import AssignmentChip from './AssignmentChip';
import { ASSIGNMENT_MODIFICATIONS_TEXT } from './text';

import styles from './styles.module.css';

const AssignmentModifications = ({ breakdown, breakdownReasons, sequences = [] }) => {
	const active = useActiveElements();

	const handleViewDetails = () => {
		const segment = deriveBreakdownSegment(breakdown, sequences);
		active.setActiveElement(MODAL_NAMES.breakdownDetails, { breakdown, segment });
	};

	return (
		<div className={styles.container}>
			<Text extraClasses={styles.title}>{ASSIGNMENT_MODIFICATIONS_TEXT.TITLE}:</Text>
			<div className={styles.content}>
				<div className={styles.chipsRow}>
					<ul className={styles.chips}>
						{breakdownReasons.map((reason) => (
							<li key={reason.reason}>
								<AssignmentChip breakdownReason={reason.reason} linkTo={reason.linkTo}>
									{reason.meta}
								</AssignmentChip>
							</li>
						))}
					</ul>
					<div className={styles.menu}>
						<Dropdown
							xPosition="left"
							yPosition="bottom"
							links={[
								<DropdownItem key="view-details" Elem="button" onClick={handleViewDetails}>
									{ASSIGNMENT_MODIFICATIONS_TEXT.viewBreakdownDetails}
								</DropdownItem>,
							]}
						>
							<Button
								appearance="link"
								display="square"
								aria-label={ASSIGNMENT_MODIFICATIONS_TEXT.menuAriaLabel}
							>
								<Icon InlineIcon={IconKebab} />
							</Button>
						</Dropdown>
					</div>
				</div>
				{breakdown.updatedAt && (
					<Text extraClasses={styles.modifiedInfo}>
						{ASSIGNMENT_MODIFICATIONS_TEXT.MODIFIED}:{' '}
						{`${formatDateDisplay(breakdown.updatedAt)} @ ${formatTime(breakdown.updatedAt)}`}
						{breakdown.updatedBy && ` ${ASSIGNMENT_MODIFICATIONS_TEXT.BY} ${breakdown.updatedBy}`}
					</Text>
				)}
			</div>
		</div>
	);
};

export default AssignmentModifications;
